import { createSelector } from 'reselect';
import { prop } from 'ramda';

export const selectCancellationDomain = prop('cancellation');

export const selectCancellationStatus = createSelector(
  selectCancellationDomain,
  prop('status')
);

export const selectCancellationBookingId = createSelector(
  selectCancellationDomain,
  prop('bookingId')
);

export const selectCancellationToken = createSelector(
  selectCancellationDomain,
  prop('token')
);

export const selectCancellationExperienceName = createSelector(
  selectCancellationDomain,
  prop('experienceName')
);
